import React,{useState,useEffect} from 'react'
import useAnalyticsConsent from '../hooks/useAnalyticsConsent'

const CONSENT_KEY='cookie_consent'

export default function CookieConsent() {
    const [visible,setVisible]=useState(false)
    const {updateAnalyticsConsent}=useAnalyticsConsent()

    useEffect(() => {
        const stored=localStorage.getItem(CONSENT_KEY)
        if(!stored) {
            setVisible(true)
        }
    },[])

    const handleAccept=() => {
        localStorage.setItem(CONSENT_KEY,'accepted')
        setVisible(false)
        if(window.__loadClarity) window.__loadClarity()
        updateAnalyticsConsent(true)
    }

    const handleDecline=() => {
        localStorage.setItem(CONSENT_KEY,'declined')
        setVisible(false)
        updateAnalyticsConsent(false)
    }

    if(!visible) return null

    return (
        <div className='fixed bottom-0 left-0 right-0 z-[9999] bg-white border-t border-gray-200 shadow-lg px-4 py-3 flex flex-col sm:flex-row items-center justify-between gap-3'>
            <p className='text-sm text-gray-700 text-center sm:text-left'>
                We use cookies and analytics tools like Microsoft Clarity to improve your experience. By accepting, you consent to our use of these technologies. See our{' '}
                <a href='/privacy' className='underline text-primary'>Privacy Policy</a>.
            </p>
            <div className='flex gap-2 shrink-0'>
                <button
                    onClick={handleDecline}
                    className='px-4 py-1.5 text-sm rounded border border-gray-300 text-gray-600 hover:bg-gray-50 transition-colors'
                >
                    Decline
                </button>
                <button
                    onClick={handleAccept}
                    className='px-4 py-1.5 text-sm rounded bg-primary text-white hover:bg-blue-700 transition-colors'
                >
                    Accept
                </button>
            </div>
        </div>
    )
}
